import {
  DSBadge,
  type DSBadgeVariant,
} from "@components/design-system/molecules";
import {
  faGauge,
  faGaugeMax,
  faLifeRing,
} from "@fortawesome/pro-solid-svg-icons";
import { type CompanionEffort } from "@hooks/use-companion-v2";

interface EffortPresentation {
  label: string;
  icon: typeof faGauge;
  variant: DSBadgeVariant;
}

const PRESENTATION: Record<CompanionEffort, EffortPresentation> = {
  standard: {
    label: "Fast",
    icon: faGauge,
    variant: "blue",
  },
  high: {
    label: "Default",
    icon: faGaugeMax,
    variant: "green",
  },
  support: {
    label: "Support",
    icon: faLifeRing,
    variant: "cyan",
  },
  support_mph: {
    label: "Support",
    icon: faLifeRing,
    variant: "cyan",
  },
};

export interface CompanionEffortBadgeProps {
  effort: CompanionEffort;
  size?: "sm" | "md";
  dataTestId?: string;
}

export const CompanionEffortBadge = ({
  effort,
  size = "sm",
  dataTestId,
}: CompanionEffortBadgeProps) => {
  const { label, icon, variant } = PRESENTATION[effort];
  return (
    <DSBadge
      variant={variant}
      size={size}
      icon={icon}
      dataTestId={dataTestId ?? `companion-effort-badge-${effort}`}
    >
      {label}
    </DSBadge>
  );
};

CompanionEffortBadge.displayName = "CompanionEffortBadge";
